import {
  Breadcrumb,
  Button,
  Card,
  Divider,
  Form,
  Input,
  Modal,
  Radio,
  Select,
} from "antd";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router";
import successIcon from "../../../assests/images/success.png";
import { NumericFormat } from "react-number-format";
import CommonOtp from "../../../components/otp";
import SendMoneyService from "../../../services/send-money.service";
import { useEffect } from "react";
import { ReactComponent as HomeIcon } from "../../../assests/images/home-line.svg";
import {
  accountListSelector,
  modeSelector,
  profileDetailsSelector,
  selectedAccountSelector,
} from "../../../store/selectors/app.selector";
import { useSelector } from "react-redux";
import TransferService from "../../../services/transfer.service";
import {
  allowOnlyAlphaNumericsShouldNotStartWithSpace,
  allowOnlyAlphaNumericsWithSpace,
  allowOnlyAlphabets,
  allowOnlyAlphabetsWithSpace,
  allowOnlyNumbers,
  amountFormat,
} from "../../../services/common.service";
import { CONFIG } from "../../../environment";
import checkedIcon from "../../../assests/images/checked.svg";
import unCheckedIcon from "../../../assests/icons/uncheck.png";
import AccountCard from "../../../components/account-card";
import { ReactComponent as TickIcon } from "../../../assests/images/tickIcon.svg";
import { ReactComponent as TitleIcon } from "../../../assests/images/transfer.svg";
import OTP from "../../../components/otp";
import { useTranslation } from "react-i18next";

const financialServiceProviders = [
  {
    code: null,
    fspCode: "501",
    fspName: "MIC Tanzania PLC - (TIGO PESA)",
    fspType: "MSISDN",
  },
  {
    code: null,
    fspCode: "502",
    fspName: "Zanzibar Telecom PLC - (EZY - PESA)",
    fspType: "MSISDN",
  },
  {
    code: null,
    fspCode: "503",
    fspName: "Vodacom Tanzania PLC - (MPESA)",
    fspType: "MSISDN",
  },
  {
    code: null,
    fspCode: "504",
    fspName: "Airtel Tanzania PLC (AIRTEL MONEY)",
    fspType: "MSISDN",
  },
  {
    code: null,
    fspCode: "505",
    fspName: "Tanzania Telecommunications Corporation - (T-PESA)",
    fspType: "MSISDN",
  },
  {
    code: null,
    fspCode: "506",
    fspName: "Viettel Tanzania PLC - (HALOPESA)",
    fspType: "MSISDN",
  },
];

export default function AddWalletPayee(props) {
  const navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [formDetails, setFormDetails] = useState({});
  const [loader, setLoader] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [verifyDetails, setVerifyDetails] = useState({});
  const [message, setMessage] = useState("");
  const [form] = Form.useForm();
  const [accountDetails, setAccountDetails] = useState({});
  const [bankDetails, setBankDetails] = useState([]);
  // const [selectedOption, setSelectedOption] = useState(null);
  const [selectedBank, setSelectedBank] = useState("");
  const mode = useSelector(modeSelector);
  const [selectedBeneType, setSelectedBeneType] = useState("TIPS");
  const [selectedModeOfBeneficiary, setSelectedModeOfBeneficiary] =
    useState("MSISDN");
  const [fspCodesList, setFspCodesList] = useState([]);
  const [fspFilteredList, setFspFilteredCodesList] = useState([]);
  const [selectedFspBank, setSelectedFspBank] = useState({});
  const [isGroupVisibility, setISGroupVisibilty] = useState(false);
  const [otp, setOtp] = useState("");
  const modeOfTransfer = [
    { label: "Bank", value: "BANK" },
    { label: "Wallet", value: "MSISDN" },
  ];
  const [successVisible, setSuccessVisible] = useState(false);
  const [cancelVisible, setCancelVisible] = useState(false);
  const { t } = useTranslation();
  const profileDetails = useSelector(profileDetailsSelector);
  const accountList = useSelector(accountListSelector);
  const selectedAccount = useSelector(selectedAccountSelector);
  // useEffect(() => {
  //   getFspCodes();
  // }, []);

  function identifyNetworkOperator(mobileNumber) {
    const prefix = mobileNumber.substring(0, 2);
    let selectedFspBank;

    if (prefix === "74" || prefix === "75" || prefix === "76") {
      selectedFspBank = financialServiceProviders[2];
    } else if (prefix === "68" || prefix === "69" || prefix === "78") {
      selectedFspBank = financialServiceProviders[3];
    } else if (prefix === "73") {
      selectedFspBank = financialServiceProviders[4];
    } else if (prefix === "61" || prefix === "62") {
      selectedFspBank = financialServiceProviders[5];
    } else if (
      prefix === "77" ||
      prefix === "71" ||
      prefix === "80" ||
      prefix === "67" ||
      prefix === "65"
    ) {
      selectedFspBank = financialServiceProviders[1];
    } else {
      return false;
    }
    setSelectedFspBank(selectedFspBank);
    return selectedFspBank;
  }

  useEffect(() => {
    if (selectedBank) {
      getBranchDetails(selectedBank);
    }
  }, [selectedBank]);

  const getFspCodes = useCallback(async () => {
    try {
      const response = await TransferService.getFspCodes();
      if (response.status === 200) {
        setFspCodesList(response.data["fspDetails"]);
        setFspFilteredCodesList(
          response.data["fspDetails"].filter((ele) => ele.fspType === "MSISDN")
        );
      }
    } catch (error) {}
  }, []);

  // const onfspBankChange = (value) => {
  //   setSelectedFspBank(fspCodesList.find((e) => e.fspCode === value));
  // };

  const getBranchDetails = useCallback(async (bankName) => {
    try {
      const response = await SendMoneyService.getBranchDetails({
        bankName: bankName,
        page: 0,
        size: 100,
      });
      if (response.status === 200) {
        setBankDetails(response.data["data"]);
      }
    } catch (error) {}
  }, []);

  const accountLookUp = useCallback(
    async (accountNo) => {
      try {
        const response = await SendMoneyService.accountLookUp({
          transferType: "TIPS",
          accountNo: "",
          bankName: selectedFspBank?.fspName,
          mobileNo: accountNo,
          custParams: {
            IDENTIFIER: selectedModeOfBeneficiary,
            FSPCODE: selectedFspBank?.fspCode,
          },
        });
        if (response.status === 200) {
          setAccountDetails(response.data);
          form.setFieldsValue({
            beneName: response.data?.customerName || undefined,
            txnCcy: response.data.accCcy,
          });
        }
      } catch (error) {
        setAccountDetails({});
      }
    },
    [selectedBank, selectedModeOfBeneficiary, selectedFspBank]
  );

  const onVerify = useCallback(
    async (values) => {
      try {
        setLoader(true);
        const srcAccDetails = accountList.find(
          (ele) => ele.accountNo === selectedAccount.accountNo
        );

        const requestParams = {
          favorites: "N",
          beneAccNo: values?.beneAccNo || values?.walletMobileNo || "",
          beneNickName: values?.beneNickName,
          beneName: accountDetails?.customerName || values?.beneName,
          maxTransferLimit:
            values?.maxTransferLimit !== undefined
              ? parseInt(
                  values?.maxTransferLimit.toString().replaceAll(/,/g, "")
                )
              : "",
          beneType: selectedBeneType,
          bankName: selectedFspBank?.fspName,
          beneBrn: selectedFspBank?.fspCode || CONFIG?.BRANCH_NAME,
          bicCode: selectedFspBank?.code,
          sortCode: "",
          beneCurrency: values?.txnCcy,
          otp: "",
          authType: "A",
          beneMobileNo: values?.walletMobileNo || "",
          beneEmail: values?.beneEmail || "",
          beneAddress: "",
          customFields: {
            DISPLAY: "MPESA",
            IDENTIFIER: selectedFspBank?.fspType,
            payerIdnfrType: selectedFspBank?.fspType,
            payeeIdnfrType: selectedFspBank?.fspType,
            payerAccCategory: "BUSINESS",
            payerAccType: "BANK",
            payeeAccCategory: "PERSON",
            payeeAccType: "WALLET",
            payerName: srcAccDetails?.accountName,
            FSPCODE: selectedFspBank?.fspCode,
          },
          visibleToGroup:
            profileDetails["retail"] !== true ? isGroupVisibility : true,
        };
        setFormDetails({ ...requestParams });
        const response = await SendMoneyService.addPayeeVerify(requestParams);
        if (response.status === 200) {
          setLoader(false);
          setVerifyDetails(response.data);
          setStage(2);
        }
      } catch (error) {
        setLoader(false);
      }
    },
    [accountDetails, selectedFspBank, isGroupVisibility]
  );

  const handleResendOtp = useCallback(
    async (values) => {
      try {
        const requestParams = {
          ...formDetails,
        };
        const response = await SendMoneyService.addPayeeVerify(requestParams);
        if (response.status === 200) {
          setLoader(false);
        }
      } catch (error) {}
    },
    [formDetails]
  );

  const onConfirm = useCallback(async (values) => {
    try {
      setLoader(true);
      const response = await SendMoneyService.addPayeeConfirm({
        ...values,
      });
      if (response.status === 200) {
        setLoader(false);
        setMessage(response.data["message"]);
        setSuccessVisible(true);
      }
    } catch (error) {
      setOtp("");
    }
  }, []);

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderConfirm();

      case 3:
        return (
          <CommonOtp
            otp={otp}
            setOtp={setOtp}
            onConfirm={(values) => onConfirm({ ...formDetails, ...values })}
            handleResendOtp={() => handleResendOtp(formDetails)}
            cancelTransaction={() => {
              navigate("/add-beneficary");
            }}
            type="ADD_PAYEE"
          />
        );
      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <div className="row">
          <p className="mb-3">
            {t("common.proceed_fill_txt", {
              defaultValue: "Please fill required details, before you proceed",
            })}
          </p>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <Form
              layout="vertical"
              initialValues={formDetails}
              onFinish={onVerify}
              form={form}
            >
              <div className="row">
                {/* <div className="col-12">
                  <Form.Item
                    name={"walletType"}
                    label="Wallet Type"
                    rules={[
                      {
                        required: true,
                        message: "Wallet Type is required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Wallet Type"
                      bordered={true}
                      optionFilterProp="children"
                      showSearch
                      size="large"
                      onChange={(value) => {
                        onfspBankChange(value);
                        form.setFieldsValue({
                          walletMobileNo: "",
                        });
                      }}
                    >
                      {fspFilteredList.map((option, idx) => (
                        <Select.Option key={idx} value={option.fspCode}>
                          {option.fspName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div> */}
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <Form.Item
                    name="walletMobileNo"
                    label={t("pages.Add_Bene.wallet_mob_no", {
                      defaultValue: "Wallet Mobile Number",
                    })}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.wallet_mobile_requir", {
                          defaultValue: "Wallet Mobile Number is required",
                        }),
                      },
                      ({ getFieldValue }) => ({
                        validator(rule, value) {
                          if (
                            !value ||
                            getFieldValue("walletMobileNo")?.length === 9
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            t("errorMesssages.wallet_mobile_valid", {
                              defaultValue:
                                "Wallet Mobile Number should be 9 digits",
                            })
                          );
                        },
                      }),
                    ]}
                  >
                    <NumericFormat
                      maxLength={9}
                      placeholder={t("pages.Add_Bene.wallet_mob_no", {
                        defaultValue: "Wallet Mobile Number",
                      })}
                      allowNegative={false}
                      customInput={Input}
                      size="large"
                      allowLeadingZeros={true}
                      onBlur={(e) => {
                        if (e.target.value.length === 9)
                          accountLookUp(e.target.value);
                      }}
                      addonBefore={CONFIG?.DEFAULT_MOBILE_PREFIX || ""}
                      onChange={(e) => {
                        identifyNetworkOperator(e.target.value);
                      }}
                    />
                  </Form.Item>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <Form.Item
                    name="beneName"
                    label={t("pages.Add_Bene.bane_name", {
                      defaultValue: "Beneficiary Name",
                    })}
                    rules={[
                      {
                        required: false,
                        message: t("pages.Add_Bene.bene_name_req", {
                          defaultValue: "Beneficiary Name is required",
                        }),
                      },
                    ]}
                  >
                    <Input
                      onKeyPress={(e) => allowOnlyAlphaNumericsShouldNotStartWithSpace(e)}
                      maxLength={CONFIG.BENE_NICKNAME_LENGTH}
                      placeholder={t("pages.Add_Bene.bane_name", {
                        defaultValue: "Beneficiary Name",
                      })}
                      size="large"
                    />
                  </Form.Item>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <Form.Item
                    name="beneNickName"
                    label={t("pages.Add_Bene.bene_nick_name", {
                      defaultValue: "Beneficiary Nick Name",
                    })}
                    rules={[
                      {
                        required: true,
                        message: t("pages.Add_Bene.bene_nick_name_req", {
                          defaultValue: "Beneficiary Nick Name is required",
                        }),
                      },
                    ]}
                  >
                    <Input
                      maxLength={CONFIG.BENE_NICKNAME_LENGTH}
                      onKeyPress={(e) => allowOnlyAlphabetsWithSpace(e)}
                      placeholder={t("pages.Add_Bene.bene_nick_name", {
                        defaultValue: "Beneficiary Nick Name",
                      })}
                      size="large"
                    />
                  </Form.Item>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <Form.Item
                    name="maxTransferLimit"
                    label={t("pages.transfer_limit.transfer_limit", {
                      defaultValue: "Transfer Limit",
                    })}
                    rules={[
                      {
                        required: true,
                        message: t("pages.transfer_limit.transfer_limit_req", {
                          defaultValue: "Transfer Limit is required",
                        }),
                      },
                      ({ getFieldValue }) => ({
                        validator(rule, value) {
                          if (
                            !value ||
                            getFieldValue("maxTransferLimit").replaceAll(
                              /,/g,
                              ""
                            ) > 0
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            t(
                              "pages.transfer_limit.trans_limit_should_greater",
                              {
                                defaultValue:
                                  "Transfer Limit should be greater than 0",
                              }
                            )
                          );
                        },
                      }),
                    ]}
                  >
                    <NumericFormat
                      type="tel"
                      size="large"
                      maxLength={12}
                      placeholder={t("pages.transfer_limit.transfer_limit", {
                        defaultValue: "Transfer Limit",
                      })}
                      allowNegative={false}
                      customInput={Input}
                      thousandSeparator={true}
                      fixedDecimalScale={false}
                      onKeyPress={(e) => allowOnlyNumbers(e)}
                    />
                  </Form.Item>
                </div>
              </div>
              <div>
                {profileDetails["retail"] !== true && (
                  <>
                    <div>
                      <span
                        style={{ marginRight: "5px ", cursor: "pointer" }}
                        onClick={() => {
                          setISGroupVisibilty(!isGroupVisibility);
                        }}
                      >
                        {isGroupVisibility ? (
                          <img
                            src={checkedIcon}
                            alt="checked"
                            width={17}
                            height={17}
                            className="checked"
                          />
                        ) : (
                          <img
                            src={unCheckedIcon}
                            alt="unchecked"
                            width={17}
                            height={17}
                            className="unchecked"
                          />
                        )}{" "}
                        {t("pages.Add_Bene.visible_to_grp", {
                          defaultValue: "Visible To Group",
                        })}
                      </span>
                    </div>
                  </>
                )}
              </div>

              <div className="d-flex align-items-center justify-content-end mt-3">
                <Button
                  type="default"
                  onClick={() => navigate("/add-beneficary")}
                  size="large"
                  className="secondary-btn mx-3"
                >
                  {" "}
                  {t("buttons.cancel_btn", {
                    defaultValue: "Cancel",
                  })}
                </Button>

                <Button
                  htmlType="submit"
                  type="primary"
                  // loading={loader}
                  size="large"
                  //disabled={Object.keys(accountDetails).length == 0}
                >
                  {" "}
                  {t("buttons.submit_btn", {
                    defaultValue: "Submit",
                  })}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </>
    );
  }

  function renderConfirm() {
    return (
      <>
        <h5 className="mb-3 bold-text">
          {" "}
          {t("common.confirmation", {
            defaultValue: "Confirmation",
          })}
        </h5>

        <p className="mb-3" style={{ fontSize: 14 }}>
          {t("pages.Add_Bene.please_check_bene_details", {
            defaultValue:
              "Please check the beneficiary details carefully, before you proceed",
          })}
        </p>
        <div className="confirm-details">
          <div className="row">
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bane_name", {
                  defaultValue: "Beneficiary Name",
                })}
              </label>
              <span>{formDetails?.beneName || "-"}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bene_nick_name", {
                  defaultValue: "Beneficiary Nick Name",
                })}
              </label>
              <span>{formDetails?.beneNickName}</span>
            </div>

            {selectedModeOfBeneficiary === "BANK" && (
              <div className="confirm-label-wrapper">
                <label>
                  {t("common.account_no_lbl", {
                    defaultValue: "Account Number",
                  })}
                </label>
                <span>{formDetails?.beneAccNo}</span>
              </div>
            )}
            {selectedModeOfBeneficiary === "BANK" && (
              <div className="confirm-label-wrapper">
                <label>
                  {t("common.bank_name", {
                    defaultValue: "Bank Name",
                  })}
                </label>
                <span>{selectedFspBank?.fspName || "-"}</span>
              </div>
            )}

            {selectedModeOfBeneficiary === "MSISDN" && (
              <>
                <div className="confirm-label-wrapper">
                  <label>
                    {" "}
                    {t("pages.Add_Bene.wallet_mob_no", {
                      defaultValue: "Wallet Mobile Number",
                    })}
                  </label>
                  <span>{formDetails?.beneAccNo}</span>
                </div>
              </>
            )}

            <div className="confirm-label-wrapper">
              <label>
                {" "}
                {t("pages.transfer_limit.transfer_limit", {
                  defaultValue: "Transfer Limit",
                })}
              </label>

              <span>
                {formDetails?.maxTransferLimit
                  ? amountFormat(
                      formDetails?.maxTransferLimit,
                      formDetails?.beneCurrency
                    )
                  : "-"}
              </span>
            </div>

            {profileDetails["retail"] !== true && (
              <div className="confirm-label-wrapper">
                <label>
                  {" "}
                  {t("pages.Add_Bene.visible_to_grp", {
                    defaultValue: "Visible To Group",
                  })}
                </label>
                <span>
                  {formDetails?.visibleToGroup === true
                    ? t("common.yes", { defaultValue: "Yes" })
                    : t("common.no", { defaultValue: "No" })}
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end mt-4">
          {/* <Button
            type="default"
            onClick={() => setCancelVisible(true)}
            size="large"
            className="secondary-btn mx-3"
          >
            Cancel
          </Button> */}
          <Button
            onClick={() => setStage(1)}
            type="default"
            className="secondary-btn mx-3"
            size="large"
          >
            {t("buttons.back_btn", {
              defaultValue: "Back",
            })}
          </Button>
          <Button
            type="primary"
            className="primary-btn"
            onClick={() =>
              verifyDetails["otpEnabled"]
                ? setStage(3)
                : onConfirm({
                    ...formDetails,
                    ...{ otp: CONFIG.DEFAULT_OTP },
                  })
            }
            size="large"
          >
            {t("buttons.confirm", { defaultValue: "Confirm" })}
          </Button>
        </div>
      </>
    );
  }

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/transfer")}>
              {" "}
              {t("navigation.transfer", {
                defaultValue: "Transfers",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span onClick={() => navigate("/add-beneficary")}>
              {t("pages.Add_Bene.title", {
                defaultValue: "Add Beneficiary",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {" "}
              {t("pages.Add_Bene.add_wallet_Bene", {
                defaultValue: "Add Wallet Beneficiary",
              })}{" "}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      <Card size="small" className="mb-1 text-center">
        <div className="row">
          <div
            className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0"
            style={{ margin: "-6px 0px" }}
          >
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <div className="d-flex" style={{ height: "25px" }}>
              <p className="title title-header hide-xs">
                {" "}
                {t("navigation.transfer", {
                  defaultValue: "Transfers",
                })}
              </p>
              <p className="Pipe hide-xs">|</p>
              <p className="beneTitle">
                {" "}
                {t("pages.Add_Bene.add_wallet_Bene", {
                  defaultValue: "Add Wallet Beneficiary",
                })}{" "}
              </p>
            </div>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 hide-xs">
          <Card className="application-card"  >
            <AccountCard currencyFilter={true} />
          </Card>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="application-card card-padding">
            {renderSwitch()}
          </Card>
        </div>
      </div>
      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {" "}
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/transfer");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        title={"Cancel ?"}
        open={cancelVisible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <p style={{ marginBottom: 30, fontSize: 15 }}>
          {t("common.commont_otp_desc", {
            defaultValue:
              "If you cancel this now, you will have to start over. Are you sure you want to cancel?",
          })}
        </p>
        <div className="mt-3" align="right">
          <Button
            className="secondary-btn"
            type="default"
            onClick={() => setCancelVisible(false)}
          >
            {t("buttons.no_btn", {
              defaultValue: "No",
            })}
          </Button>
          <Button
            type="primary"
            className="primary-btn"
            style={{ marginLeft: 20 }}
            onClick={() => {
              setCancelVisible(false);
              navigate("/add-beneficary");
            }}
          >
            {t("buttons.yes_btn", {
              defaultValue: "Yes",
            })}
          </Button>
        </div>
      </Modal>
    </>
  );
}
